import { Link, useParams, useNavigate } from 'react-router-dom';
import Header from '../../common/ahbaab/Header/Header';
import Footer from '../../common/ahbaab/Footer/Footer';
import OurProductData from '../../data/ahbaab/OurProductData';
import { Box, Button } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import ErrorPage from './ErrorPage';
import '../../styles/ahbaab/ProductDetailOfEachStyle.css';
import { FaRegCheckSquare } from 'react-icons/fa';
import { FaSquareArrowUpRight } from 'react-icons/fa6';

const ProductDetailOfEach = () => {
    const { linkTag, productCategoryLink } = useParams(); // ✅ changed
    const navigate = useNavigate();

    // Find selected main category
    const categoryData = OurProductData.find(item => item.linkTag === linkTag);

    // Find product inside all subcategories
    let product, parentSubcategory;
    categoryData?.category.forEach(sub => {
        const found = sub.productCategory?.find(p => p.productCategoryLink === productCategoryLink);
        if (found) {
            product = found;
            parentSubcategory = sub;
        }
    });

    if (!product) return <ErrorPage />;

    const detail = product?.productCategoryDetail?.[0]; // safe access

    return (
        <>
            <Header />

            <Box className='product-detailwrapper'>

                <Box className="product-detailwrapper_home row">
                    <div className="imggdiv col-lg-6 col-12">
                        <img src={product.productCategoryImge} alt={product.productCategoryImge} />
                    </div>

                    <div className="textdiv col-lg-6 col-12">
                        <p className='heading'>{categoryData.heading}</p>
                        <h6>{product.productCategoryName}</h6>

                        {/* Description */}
                        
                        {/* {detail?.productCategorytextInfo && <p className='textinfo'>{detail.productCategorytextInfo}</p>} */}

                        {/* Features */}

                        {/* {detail?.productCategoryfeatures?.length > 0 && (
                            <>
                                <p className='FeaturesHeading'>Features</p>
                                {detail.productCategoryfeatures.map((point, idx) => (
                                    <div key={idx} className='FeaturesHeadingdata'>
                                        <div><FaRegCheckSquare className='hed-icon' /></div>
                                        <div><h3>{point}</h3></div>
                                    </div>
                                ))}
                            </>
                        )} */}

                        {/* Buttons */}
                        <div className="textdiv-contact-btndiv">
                            <Link to={`/contact-us`}>
                                <Button className='butnn11'>
                                    SEND INQUIRY <FaSquareArrowUpRight className="iconbtnb" />
                                </Button>
                            </Link>
                            {/* <Link to="https://wa.me/918448783350?text=Hi">
                                <Button className='butnn22'>
                                    WhatsApp <WhatsApp className="iconbtnb" />
                                </Button>
                            </Link> */}
                        </div>
                    </div>
                </Box>
            </Box>

            {/* Related Products */}
            {parentSubcategory?.productCategory?.length > 1 && (
                <Box className='related-products-section'>
                    <h2 className='related-heading'>Related Products</h2>
                    <div className="d-flex flex-wrap justify-content-center">
                        {parentSubcategory.productCategory
                            .filter(p => p.productCategoryLink !== productCategoryLink)
                            .map((item, i) => (
                                <div key={i} className="card-box">
                                    <Link to={`/products/${linkTag}/${item.productCategoryLink}`}>
                                        <div className="card-img-div1">
                                            <img src={item.productCategoryImge} alt={item.productCategoryImge} />
                                            <h6>{item.productCategoryName}</h6>
                                        </div>
                                    </Link>
                                   
                                    {/* <div className="card-content-div">
                                        <Link to={`/products/${linkTag}/${item.productCategoryLink}`}>
                                            <Button>
                                                View More <FaSquareArrowUpRight className="iconbtnb" />
                                            </Button>
                                        </Link>
                                        <Link to="https://wa.me/918448783350?text=Hi">
                                            <Button>
                                                WhatsApp <WhatsApp className="iconbtnb" />
                                            </Button>
                                        </Link>
                                    </div> */}

                                </div>
                            ))}
                    </div>
                </Box>
            )}

            <Footer />
        </>
    );
};

export default ProductDetailOfEach;
